import { render, staticRenderFns } from "./BatchesHistoryPage.vue?vue&type=template&id=bd485efe&scoped=true&"
import script from "./BatchesHistoryPage.vue?vue&type=script&lang=js&"
export * from "./BatchesHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./BatchesHistoryPage.vue?vue&type=style&index=0&id=bd485efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd485efe",
  null
  
)

export default component.exports